exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home[data-v-f06d720e]{height:100%;width:100%;min-width:500px;position:relative}.home header[data-v-f06d720e]{width:100%;height:70px}.home section[data-v-f06d720e]{position:absolute;top:70px;bottom:0;left:0;right:0;padding:0}", ""]);

// exports
